module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aEHnI"))).then(() => parcelRequire('2KbAe'));